<div class="progress-wrapper">
  <div class="progress {{ circleClass }}">
    <div class="progress--circle" [class]="progress ? 'progress--' + progress : 'progress--0'">
      <div class="circle-content {{ contentClass }}">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
